import { assocPath } from "ramda";

import { Event, mapQueryToString } from "lib/build/events";
import { Value } from "lib/build/schema";

import { api } from "src/common/utils/api";
import { Default } from "src/features/defaults/types";

interface FetchDefaultsOptions {
	org: string;
	mod: string;
	patientId: string;
	defaults: Default[];
}

export async function fetchDefaults({
	org,
	mod,
	patientId,
	defaults
}: FetchDefaultsOptions): Promise<Value> {
	let value: Value = {};
	for (const { path, query } of defaults) {
		const { data: events } = await api.get<Event[] | null>(
			`/events/${patientId}/last?organization=${org}&module=${mod}&n=1&i=${mapQueryToString(
				query
			)}`
		);
		if (events !== null && events.length !== 0) {
			value = assocPath(path, events[0].value, value);
		}
	}
	return value;
}
